import {HOTSPOT_ACTIONS} from "./hotspot-map";

const HOTSPOT_CLASS_PREFIX = 'hotspot'

function extractHotspotName(classList = '') {
    const results = classList.split(' ')
        .filter(Boolean)
        .filter(item => item.startsWith(HOTSPOT_CLASS_PREFIX))
        .filter(item => item.startsWith(`${HOTSPOT_CLASS_PREFIX}--`))
    return results[0] || ''
}

export function handleHotspotAction(classList, openOverlay) {
    const type = extractHotspotName(classList)
    const actionConfig = processClick(type);
    openOverlay(actionConfig)
}

function processClick(type) {
    const actionConfig = HOTSPOT_ACTIONS[type]
    if (!actionConfig) {
        return;
    }
    return actionConfig;
}